{
  "name": "phdsoftapp",
  "version": "1.0.1652",
  "scripts": {
    "ng": "ng",
    "start": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng serve",
    "local": "yarn build:tests & yarn local:run",
    "local:run": "cd dist/phdsoftapp & npx ws -c ..\\..\\lws.config.js",
    "touch": "ng serve --host 0.0.0.0 --disableHostCheck",
    "build": "ng build",
    "test": "ng test --watch=false",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "prebuild": "npm --no-git-tag-version version patch",
    "build:dev": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng build --project phdsoftapp --configuration=dev --output-hashing=all --delete-output-path && yarn brotli_compress",
    "build:stage": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --project phdsoftapp --configuration=stage --output-hashing=all --delete-output-path && yarn brotli_compress",
    "build:prod": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration production --project phdsoftapp --output-hashing=all --delete-output-path && yarn brotli_compress",
    "build:dev:swa": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --project phdsoftapp --configuration=dev --output-hashing=all --delete-output-path",
    "build:stage:swa": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --project phdsoftapp --configuration=stage --output-hashing=all --delete-output-path",
    "build:prod:swa": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration production --project phdsoftapp --output-hashing=all --delete-output-path",
    "brotli_compress": "node brotli-compress.js",
    "build:base-form": "ng build @phdsoft/base-form --configuration production",
    "build:common": "ng build @phdsoft/common --configuration production",
    "build:formly": "ng build @phdsoft/formly --configuration production",
    "build:w": "ng build @phdsoft/window --configuration production",
    "build:modal-confirm": "ng build @phdsoft/modal-confirm --configuration production",
    "build:pipes": "ng build @phdsoft/pipes --configuration production",
    "build:theme": "ng build @phdsoft/theme",
    "build:pw": "ng build @phdsoft/properties-window --configuration production",
    "build:components": "npm run build:base-form && npm run build:formly && npm run build:w && npm run build:modal-confirm && npm run build:pw",
    "build:phdsoft": "npm run build:pipes && npm run build:common && npm run build:theme && npm run build:components"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/eslint-plugin": "^17.1.0",
    "@angular-slider/ngx-slider": "^18.0.0",
    "@angular/animations": "18.2.13",
    "@angular/cdk": "18.2.14",
    "@angular/common": "18.2.13",
    "@angular/compiler": "18.2.13",
    "@angular/core": "18.2.13",
    "@angular/forms": "18.2.13",
    "@angular/localize": "18.2.13",
    "@angular/material": "18.2.14",
    "@angular/platform-browser": "18.2.13",
    "@angular/platform-browser-dynamic": "18.2.13",
    "@angular/router": "18.2.13",
    "@angular/service-worker": "18.2.13",
    "@angular/youtube-player": "^18.2.14",
    "@ecodev/fab-speed-dial": "^17.0.0",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-brands-svg-icons": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.4.2",
    "@mapbox/mapbox-gl-draw": "^1.4.3",
    "@mapbox/mapbox-gl-geocoder": "^5.0.2",
    "@microsoft/signalr": "^8.0.0",
    "@ngrx/store": "^18.1.1",
    "@ngx-formly/core": "^6.2.2",
    "@ngx-formly/material": "^6.2.2",
    "@ngx-formly/primeng": "^6.2.2",
    "@ngx-formly/schematics": "^6.2.2",
    "@ngx-pwa/local-storage": "^18.0.0",
    "async-mutex": "^0.5.0",
    "avsc": "^5.7.9",
    "bootstrap": "5.2.3",
    "brotli": "^1.3.2",
    "buffer": "^6.0.3",
    "chart.js": "^3.9.1",
    "chartjs-adapter-moment": "^1.0.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "chartjs-plugin-zoom": "^2.0.1",
    "chroma-js": "^3.1.2",
    "core-js": "3.33.2",
    "crypto-js": "^4.2.0",
    "d3": "^7.8.5",
    "date-fns": "2.14.0",
    "dayjs": "^1.11.10",
    "echarts": "^5.4.3",
    "file-saver": "^2.0.5",
    "hash-it": "^6.0.0",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.10.1",
    "js-base64": "^3.7.5",
    "jspdf": "^2.3.1",
    "jszip": "^3.10.1",
    "lil-gui": "^0.20.0",
    "mapbox-gl": "3.1.0",
    "mapbox-gl-geocoder": "^2.0.1",
    "mapbox-gl-style-switcher": "^1.0.11",
    "meshoptimizer": "^0.24.0",
    "ng-connection-service": "^15.0.0",
    "ng-gallery": "^11.0.0",
    "ng-qrcode": "^18.0.0",
    "ng2-charts": "^5.0.4",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-echarts": "^17.1.0",
    "ngx-extended-pdf-viewer": "^25.6.0-alpha.3",
    "ngx-indexed-db": "^16.0.0",
    "ngx-quill": "^26.0.10",
    "ngx-toastr": "13.0.0",
    "nouislider": "14.6.2",
    "primeflex": "^3.3.1",
    "primeicons": "^5.0.0",
    "primeng": "^17.18.15",
    "quill": "^2.0.3",
    "rxjs": "7.8.1",
    "store": "^2.0.12",
    "three": "0.182.0",
    "three-csg-ts": "^3.1.13",
    "ts-md5": "^1.2.7",
    "tslib": "^2.6.2",
    "util": "^0.12.5",
    "uuid": "^9.0.1",
    "xlsx-js-style": "^1.2.0",
    "yarn": "^2.4.3",
    "zone.js": "^0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.14",
    "@angular/cli": "18.2.14",
    "@angular/compiler-cli": "18.2.13",
    "@types/brotli": "^1.3.4",
    "@types/chart.js": "^2.9.41",
    "@types/file-saver": "^2.0.7",
    "@types/googlemaps": "^3.43.3",
    "@types/jasmine": "~3.5.0",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^17.0.45",
    "@types/three": "0.182.0",
    "autoprefixer": "^10.4.19",
    "eslint": "^7.24.0",
    "jasmine-auto-spies": "^8.0.1",
    "jasmine-core": "^5.5.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ng-packagr": "^18.2.1",
    "postcss": "^8.4.38",
    "protractor": "~7.0.0",
    "tailwindcss": "^3.4.17",
    "ts-node": "~8.3.0",
    "tslint": "6.1.3",
    "typescript": "5.4"
  },
  "description": "This project was generated with [Angular CLI](https://github.com/angular/angular-cli) version 10.1.5.",
  "directories": {
    "test": "tests"
  },
  "repository": {
    "type": "git",
    "url": "https://phdsoft.visualstudio.com/shell%20digital%20twin/_git/c4dweb.frontend"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "resolutions": {
    "@typescript-eslint/utils": "6.19.0"
  }
}
